module.exports = __webpack_public_path__ + "img/image_region-228410d7.png";